import { createLocalStorageHook } from '@/hooks/browser/createLocalStorageHook'
import { PrinterAddressSchema } from '@/business/printer-address'

export const useBagTagPrinter = createLocalStorageHook(
  'bag-tag-printer',
  PrinterAddressSchema.optional()
)
